module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17950/js/img/valuePropModals/FormConditionalLogic/ValueProp3.svg"